/* ============================================================
   wow-card.js
   Ajout au panier en AJAX pour les cartes produit enrichies.

   Pourquoi une délégation d'événement plutôt qu'une boucle sur
   les formulaires : ce script est chargé une seule fois pour tout
   le site, alors que les cartes apparaissent en nombre variable et
   parfois APRÈS le chargement de la page (filtres de collection,
   pagination infinie, tiroir de recherche). Un écouteur unique posé
   sur le document capte aussi bien les cartes présentes au départ
   que celles injectées plus tard — une boucle, elle, ne verrait
   jamais les secondes.

   Correctif du 30/09/2026 — « Votre panier est vide » au 1er ajout
   ------------------------------------------------------------
   Avant : le script ajoutait le produit puis se contentait de mettre
   à jour la pastille. Le tiroir panier n'était jamais redessiné, et
   il gardait l'étiquette « is-empty » posée par Dawn quand la page
   s'était chargée avec un panier vide. Résultat : tout nouveau
   visiteur voyait « Votre panier est vide » juste après son ajout.

   Maintenant : on suit exactement le mécanisme natif de Dawn
   (celui de product-form.js) :
     1. on demande à Shopify, dans la même requête que l'ajout,
        le HTML à jour du tiroir et de l'icône panier ;
     2. on laisse le tiroir se redessiner avec sa propre méthode
        renderContents(), qui l'ouvre aussi ;
     3. on retire l'étiquette « is-empty ».
   Si le thème n'a ni tiroir ni notification (réglage « page
   panier »), on garde l'ancien comportement : pastille seule.
   ============================================================ */

(function () {
  'use strict';

  // Le composant panier de Dawn présent sur la page : tiroir ou notification.
  function getCartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  // Ancien comportement, conservé en repli : met à jour la pastille seule.
  function refreshBubbleOnly() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (bubble) bubble.textContent = cart.item_count;

        var bubbleWrap = document.querySelector('.cart-count-bubble');
        if (bubbleWrap) bubbleWrap.hidden = false;
      })
      .catch(function () {});
  }

  // Prévient les autres composants Dawn (page panier, etc.) et tout
  // script qui écoute l'ancien événement « cart:updated ».
  function announceCartUpdate(response, variantId) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId,
          cartData: response
        });
      }
    } catch (e) {}

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: response } }));
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target.closest('.fp-card__form');
    if (!form) return;

    evt.preventDefault();

    var button = form.querySelector('.fp-card__button');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    var cart = getCartComponent();
    var canRender = !!(cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function');

    var formData = new FormData(form);
    var variantId = formData.get('id');

    // Étape 1 : on demande le HTML à jour du tiroir dans la même requête.
    if (canRender) {
      var sectionIds = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      formData.append('sections', sectionIds.join(','));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    }

    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(function (response) {
        button.classList.remove('is-loading');
        button.classList.add('is-added');

        // Étapes 2 et 3 : redessiner le tiroir et retirer « is-empty ».
        // Un échec ici ne doit pas casser l'ajout, déjà réussi côté serveur.
        var rendered = false;
        if (canRender && response && response.sections) {
          try {
            cart.renderContents(response);
            cart.classList.remove('is-empty');
            var inner = cart.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
            rendered = true;
          } catch (e) {
            rendered = false;
          }
        }

        if (!rendered) refreshBubbleOnly();

        announceCartUpdate(response, variantId);

        setTimeout(function () {
          button.classList.remove('is-added');
        }, 1600);
      })
      .catch(function () {
        // Repli : si l'AJAX échoue (réseau, stock épuisé entre-temps),
        // on laisse le formulaire partir en soumission classique pour
        // que le client voie le message d'erreur natif de Shopify.
        button.classList.remove('is-loading');
        form.submit();
      });
  });
})();